import * as React from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Icon from '../common/Icon';
import { SupportedIcons } from '../common/Icon';
import clsx from 'clsx';
import { NavigationContext } from '../_navigation/NavigationContext';
import Divider from '@material-ui/core/Divider';
import { Link } from 'react-router-dom';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../_auth/AuthContext';
import { IPermissionChecker } from '../_types/user';



interface Props {
    children: any,
    classes?: any,
    label: string,
    menuKey: string,
    iconName: SupportedIcons,
    path: string,
    checkPermission?: IPermissionChecker
};

const useStyles = makeStyles((theme: Theme) =>
createStyles({
    menuItem: {
      fontWeight: "bold",
      textDecoration: "none",
      color: theme.palette.primary.dark
    },
    menuItemSelected: {
      extend: 'menuItem',
      fontStyle: 'italic'
    }

  })
);

interface INavGroupState {
  open: boolean,
  display: boolean,
  selected: boolean
};
const defaultNGState: INavGroupState = {
  open: false,
  display: true,
  selected: false
};


const NavGroup: React.FC<Props> = (props: Props) => {

    //my state
    const [ngState, setNGState] = useState(defaultNGState);

    //detect outside changes to route
    const history = useHistory();
    //control nav context
    const { nav, setNav } = useContext(NavigationContext);
    //inspect user
    const { user, setUser } = useContext(AuthContext);
    

    const classes = useStyles();
    
  
    const setMenuState = (state: boolean, props: Props) => {

      let menu = nav.openMenus.filter(e => e.key !== props.menuKey);
      menu.push({key: props.menuKey, open: state});

      nav.openMenus = menu;

      setNav({...nav});
      setNGState(prv => ({...prv, open: state}));
      //setOpen(state);
    }


    //watch any changes to route not done by me.
    React.useEffect(() => {
      return history.listen((location) => {

        let menuPath = props.path.split('/');
        let routePath = location.pathname.split('/');
        
        let sel = ((menuPath[1] === routePath[1] || (props.path === location.pathname)));
        if (sel) {
          
          setMenuState(true, props);
          
        } 
        //setSelected(selected);
        setNGState(prv => ({...prv, selected: sel}));
        

      })
    }, [history])


    React.useEffect(() => {

      if (props.checkPermission) {
        props.checkPermission(user, setUser).then(r => setNGState((prv) => { return {...prv, display: r}})); 
      }

    }, []);

    React.useEffect(() => {

      if (props.checkPermission) {
        props.checkPermission(user, setUser).then(r => {
          if (!r && ngState.selected) {
            setNGState((prv) => { return {...prv, display: r, open: false}})
          } else {
            setNGState((prv) => { return {...prv, display: r}});
          }
          
        }); 
      }
    }, [user]);

    const GetIcon = (props: Props) => {
      if (props.iconName) {
        return (<ListItemIcon><Icon iconName={props.iconName}/></ListItemIcon>);
      } else {
        return (<span/>);
      }
    }


    return ngState.display ? (
          
          <div>
              { (ngState.open && props.children.length > 1) && (<Divider/>)}
              { (!ngState.open || props.children.length === 1) && (
                //if I, or any of my children are selected, I just wanna open... don't want to nav to path
                ngState.selected ? (
                  <Link to={props.path} style={{textDecoration: 'none'}}>
                  <ListItem button key={props.menuKey}>
                      { GetIcon(props) }
                      <ListItemText className={clsx(classes.menuItem, ngState.selected && classes.menuItemSelected )} primary={props.label} onClick={() => setMenuState(true, props)} >{props.label}</ListItemText>
                      
                  </ListItem>
                  </Link>
                ) : (
                  <Link to={props.path} style={{textDecoration: 'none'}}>
                    <ListItem button key={props.menuKey}>
                        { GetIcon(props) }
                        <ListItemText className={clsx(classes.menuItem, ngState.selected && classes.menuItemSelected )} primary={props.label}>{props.label}</ListItemText>
                        
                    </ListItem>
                  </Link>
                )
              )
              }
              { ngState.open && props.children.length > 1 && //if only one child, don't display since the group navs to the same place
                (
                  <ListItem button key={props.menuKey} onClick={() => setMenuState(false, props)}>
                    <ListItemText primary={props.label}>{props.label}</ListItemText>
                  
                  </ListItem> 
                )                             
              }
              { ngState.open && props.children.length > 1 && props.children }
              { ngState.open && props.children.length > 1 && (<Divider/>)}
          </div>
    ) : ( <div/> )
    //          { (selected && !props.subMenu) ? <Divider/> : "" }
};

export default NavGroup;
